import { IGetUnregisterBillRes } from "src/service/types/pay.type";
import { useGetUnregisterBill } from "./useGetUnregisterBill";

interface IUseGetPayUnregisterBillProps {
  enabled?: boolean;
  onSuccess?: (serviceList: IGetUnregisterBillRes[]) => void;
  onError?: () => void;
}
// Bill페이지 에서 사용할 구매이력 정보 (PAY)
export function useGetPayUnregisterBill(props: IUseGetPayUnregisterBillProps = {}) {
  const { isLoading, isSuccess, data } = useGetUnregisterBill("PAY", props);
  return { isLoading, isSuccess, unregisterPayList: data };
}
